export class ExtraInfo {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    type= "",
                    input_type= "",
                    input_label= "",
                    input_config= {},
                } = {}) {

        //fill attributes
        this.id=id;
        this.company_id=company_id;
        this.type=type;
        this.input_type=input_type;
        this.input_label=input_label;
        this.input_config=input_config;

    }
}

export function createExtraInfo(data={}) {
    return Object.freeze(new ExtraInfo(data));
}